module.exports = __webpack_public_path__ + "static/media/pink-background.1fcb587a.svg";